function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 24.5,
  stroke: "black",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9166 32.9583V35.5417C22.9166 36.2268 22.6445 36.8839 22.16 37.3684C21.6755 37.8528 21.0185 38.125 20.3333 38.125C19.6482 38.125 18.9911 37.8528 18.5066 37.3684C18.0222 36.8839 17.75 36.2268 17.75 35.5417V17.4583C17.75 16.7732 17.4778 16.1161 16.9933 15.6316C16.5089 15.1472 15.8518 14.875 15.1666 14.875C14.4815 14.875 13.8244 15.1472 13.34 15.6316C12.8555 16.1161 12.5833 16.7732 12.5833 17.4583V21.3333H16.4583",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.4166 32.9583V35.5416C38.4166 36.2267 38.1445 36.8838 37.66 37.3683C37.1755 37.8527 36.5185 38.1249 35.8333 38.1249H20.3333",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5417 32.9583V17.4583C34.5417 16.7732 34.2695 16.1161 33.785 15.6316C33.3006 15.1472 32.6435 14.875 31.9584 14.875H15.1667",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.4167 32.9583H22.9167",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFeatureIcon6 = function SvgFeatureIcon6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeatureIcon6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/featureIcon6.922cf2e3.svg";
export { ForwardRef as ReactComponent };